import { PBROption } from '@/app/assets/actions/importOptions';
import { Box, Group, HoverCard, Select, Stack, Text, TextInput } from '@mantine/core';
import QuestionMarkIcon from '@/icons/question-mark.svg';
import { ControlledOptionsSwitcher } from '@/app/components/shared/navigation/OptionsSwitcher';
import { UseFormReturnType } from '@mantine/form';

interface PBROptionFieldProps {
  option: PBROption;
  form: UseFormReturnType<Record<string, any>>;
}

export function PBROptionField({ option, form }: PBROptionFieldProps) {
  return (
    <Stack gap={4}>
      <Group gap='xs'>
        <Text fw={600}>{option.display_name}</Text>
        <HoverCard width={280} shadow='md'>
          <HoverCard.Target>
            <Box>
              <QuestionMarkIcon />
            </Box>
          </HoverCard.Target>
          <HoverCard.Dropdown>
            <Text size='sm'>{option.description}</Text>
          </HoverCard.Dropdown>
        </HoverCard>
      </Group>
      {option.type === 'text' && (
        <TextInput
          required={option.config.requiresValue}
          placeholder={option.options.placeholder}
          {...form.getInputProps(option.config.property)}
        />
      )}
      {option.type === 'boolean' && (
        <ControlledOptionsSwitcher
          options={
            option.options.values?.map((o) => ({
              label: o.name,
              value: o.value,
            })) ?? []
          }
          onChanged={(v) => form.setFieldValue(option.config.property, v)}
          value={form.values[option.config.property]}
        />
      )}
      {option.type === 'dropdown' && (
        <Select
          data={option.options.values?.map((o) => ({
            label: o.name,
            value: o.value,
          }))}
          comboboxProps={{ withinPortal: false }}
          {...form.getInputProps(option.config.property)}
        />
      )}
    </Stack>
  );
}
